import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../redux/store";

const selectEntryCode = (state: RootState) => state.entryCode.value;

export const entryCodeSelector = createSelector(
  [selectEntryCode],
  (entryCode) => entryCode
);
